import React, { ReactNode, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { InitInfo, UserData } from './types';
import { UserDataContext } from './context';
import { userDataApi } from './userData.api';

type UserDataContextProviderProps = {
  children: ReactNode;
};

export const UserDataContextProvider = ({ children }: UserDataContextProviderProps) => {
  const [userData, setUserData] = useState<UserData | null>(null);
  const [isUserDataLoading, setIsUserDataLoading] = useState<boolean>(true);
  const [initInfo, setInitInfo] = useState<InitInfo | null>(null);
  const location = useLocation();

  const getUserData = () => {
    setIsUserDataLoading(true);
    userDataApi.get().then((data) => {
      setUserData(data);
      setIsUserDataLoading(false);
      if (!initInfo) {
        userDataApi.getInitInfo().then(setInitInfo);
      }
    });
  };

  useEffect(() => {
    getUserData();
  }, [location]);

  return (
    <UserDataContext.Provider value={{ userData, isUserDataLoading, initInfo, getUserData }}>
      {children}
    </UserDataContext.Provider>
  );
};
